import { Seo } from "../components/site/Seo";
import { MaskLines, Eyebrow } from "../components/site/Reveal";
import { ContactList } from "../components/site/Sections";
import { QuoteForm } from "../components/site/QuoteForm";

export default function ContactosPage({ quote = false }) {
  const path = quote ? "/pedir-orcamento" : "/contactos";
  return (
    <>
      <Seo path={path}
        title={quote ? "Pedir Orçamento Gratuito | Mega Solar" : "Contactos | Mega Solar"}
        description={quote ? "Peça um orçamento gratuito para a instalação de painéis solares na sua habitação ou empresa. Resposta da equipa Mega Solar." : "Contacte a Mega Solar por telefone, WhatsApp ou e-mail, ou envie um pedido de orçamento para a instalação de painéis solares."} />
      <section data-testid={quote ? "quote-page" : "contact-page"} className="relative bg-paper pt-32 pb-24 sm:pt-40 sm:pb-32">
        <div className="container-x grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Eyebrow>{quote ? "Pedido de orçamento" : "Contactos"}</Eyebrow>
            <MaskLines testId="contact-title" className="mt-6 font-display text-[2.6rem] font-semibold leading-[0.95] tracking-tighter text-forest sm:text-6xl"
              lines={quote ? ["Vamos analisar", "a sua solução", "solar."] : ["Fale com a", "Mega Solar."]} />
            <p className="mt-8 max-w-md text-base leading-relaxed text-ink/80 md:text-lg">
              {quote ? "Preencha o formulário — o pedido de orçamento é gratuito e sem compromisso. Também pode contactar-nos diretamente." : "Escolha o canal que preferir ou envie um pedido de orçamento. Respondemos com a maior brevidade possível."}
            </p>
            <div className="mt-10"><ContactList /></div>
          </div>
          <div className="lg:col-span-7"><QuoteForm origem={quote ? "pedir-orcamento" : "contactos"} /></div>
        </div>
      </section>
    </>
  );
}
